import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Row, Col } from 'reactstrap';
import { useParams } from "react-router-dom";
import InvoicesDataTable from "./components/InvoicesDataTable";
import ViewInvoice from './components/ViewInvoice';
import { useReportProgramIds } from "../components/ReportProgramsPage";

const Invoices = (props) => {
    const { invoiceId } = useParams();
    const [step, setStep] = useState(0);
    const [invoice, setInvoice] = useState(null);
    const [trigger, setTrigger] = useState(0);
    const {
      isLoadingPrograms,
      programLoadError,
      programIds,
    } = useReportProgramIds(props.organization?.id, props.program?.id);

    useEffect(() => {
        if (invoiceId) {
            setInvoice({ id: invoiceId });
            setStep(1);
            return;
        }

        setInvoice(null);
        setStep(0);
    }, [invoiceId]);

    if (invoiceId && !invoice) {
      return (
        <section className="manager-report-panel manager-report-panel--state">
          Loading invoice...
        </section>
      );
    }

    if (isLoadingPrograms) {
      return (
        <section className="manager-report-panel manager-report-panel--state">
          Loading Cocard invoices...
        </section>
      );
    }

    if (programLoadError) {
      return (
        <section className="manager-report-panel manager-report-panel--state">
          {programLoadError}
        </section>
      );
    }

    if (programIds.length === 0) {
      return (
        <section className="manager-report-panel manager-report-panel--state">
          No programs are available for this report.
        </section>
      );
    }

    const invoiceProps = {
        ...props,
        setStep,
        trigger,
        setTrigger
    };

    return (
      <section className="manager-report-legacy">
        {step === 0 && <InvoicesDataTable setInvoice={setInvoice} programs={programIds} {...invoiceProps} />}
        {step === 1 && (
          <Row className="justify-content-center mx-0">
            <Col md={8}>
              <ViewInvoice invoice={invoice} {...invoiceProps} />
            </Col>
          </Row>
        )}
      </section>
    )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(Invoices);
